// extracted by mini-css-extract-plugin
export default {"walletAddress":"WalletAddress_walletAddress__FyvfS","address":"WalletAddress_address__B-ifg","copyButton":"WalletAddress_copyButton__WZDP6","copied":"WalletAddress_copied__vCm+y"};